import pl from "./pl";
import en from "./en";

export const messages = {
  pl,
  en,
};
